import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 529FA74E-39AF-4AF4-BAD3-637FDFBD53AE
 * name cards-diamond-outline
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cards-diamond-outline.svg
 * tags
 * - Transportation + Road 
 */
export const CardsDiamondOutlineIcon = createSvgIcon(<><path d="M12 2L5 12L12 22L19 12M7.44 12L12 5.5L16.56 12L12 18.5" /></>, 'CardsDiamondOutlineIcon');
export default CardsDiamondOutlineIcon